import React, { useEffect, useRef } from 'react';
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/css/okta-sign-in.min.css';
import { OKTA_CLIENT_ID, OKTA_DOMAIN, OKTA_REDIRECT_URI } from 'utils/config.js';
import centsBlueLogo from '../../assets/images/cents_logo_blue.svg';

const Login = ({ oktaAuth }) => {
  const widgetRef = useRef();

  useEffect(() => {
    const signIn = new OktaSignIn({
      baseUrl: OKTA_DOMAIN,
      clientId: OKTA_CLIENT_ID,
      redirectUri: OKTA_REDIRECT_URI,
      authParams: {
        issuer: `${OKTA_DOMAIN}/oauth2/default`,
        responseType: ['id_token', 'token'],
        scopes: ['openid', 'profile', 'email'],
      },
    });

    signIn.renderEl({ el: widgetRef.current }, async (res) => {
      if (res.status === 'SUCCESS') {
        // Use the shared oktaAuth instance so Security/SecureRoute sees the tokens,
        // then let restoreOriginalUri handle the redirect.
        await oktaAuth.handleLoginRedirect(res.tokens);
      }
    });

    return () => {
      signIn.remove();
    };
  }, [oktaAuth]);

  return (
    <div className="common-background">
      <div className="login-container">
        <img className="cents-logo" src={centsBlueLogo} alt="Cents Blue Logo" />
        <div ref={widgetRef} />
      </div>
    </div>
  );
};

export default Login;
